import React, { useEffect } from "react"
import { observer } from "mobx-react"
import "./HowItWorks.less"
import AppStore from "../../Configs/Store"
import Howjson from "../../Configs/JSON/HowItWorks.json"
import HowWorkModal from "./HowWorkModal"
import SmallButton from "../Common/smallButton"
import { DataLayerFn } from "../../Configs/API"
import CommonStore from "../../Configs/Store/common"
import DataJson from "../../Configs/JSON/KnowMoreModal.json"

import Icon1 from "../../assets/KnowMoreModal/Icon1.svg"
import Icon2 from "../../assets/KnowMoreModal/Icon2.svg"
import Icon3 from "../../assets/KnowMoreModal/Icon3.svg"
import Icon4 from "../../assets/KnowMoreModal/Icon4.svg"
import Icon5 from "../../assets/KnowMoreModal/Icon5.svg"

const HowItWorks = observer(() => {
  useEffect(() => {
    console.info("HowItWorksJson", HowItWorksJson)
  }, [AppStore.device])
  const HowItWorksJson = Howjson.Extracontent

  const device = AppStore.device
  const ModalOpen = () => {
    CommonStore.setAIModal(true)
  }

  return (
    <div className="HowItWorksRoot">
      <div className="HowItWorksContainer">
        <div className="HowItWorksHead">
          <h2 className="HowItWorksTitle">{Howjson.TitleText}</h2>
          <div className="HowItWorksSubTitle">{Howjson.subTitleText}</div>
        </div>
        <div className="HowItWorksDataContainer">
          {device === 1 && (<div>
            <img src="assets/HowItWorks/HowItWorks.svg" alt="" className="HowItWorksPC" />
            {/* <div className="HowItWorkPC">
              <div className="HowItWorkContainer">
                <div className="HowItWorkCard1">
                  <div className="HowItWorks1">
                    <img className="HowItWorksMobileImg" src={Icon4} />
                    <div className="HowItWorks1stcontent">
                      <div className="HowItContent">{DataJson.text1}</div>
                      <div className="HowItSubContent">{DataJson.text2}</div>
                    </div></div>
                  <p className="Text3" dangerouslySetInnerHTML={{ __html: DataJson.text3 }}></p>
                </div>
                <div className="HowItWorkCard2">
                  <div className="HowItWorkMain">
                    <div className="MainImg" >
                      <img className="Image2" src={Icon3} alt="icon" />
                      <span>{DataJson.text4}</span>
                    </div>
                    <div className="MainContent">
                      <div className="Content1">
                        <div className="Icon1">
                          <img src={Icon1} alt='Icon1' style={{
                            width: "40px",
                            height: "40px"
                          }} />
                          <span className="text8">{DataJson.text8}</span>
                        </div>
                        <div className="Icon2">
                          <img src={Icon2} alt='Icon2' />
                          <span className="text5" dangerouslySetInnerHTML={{ __html: DataJson.text5 }}></span>
                        </div>
                      </div>
                      <div className="Content2">
                        <img src={Icon5} className='Icon5' />
                        <span className="text9">{DataJson.text9}</span>
                        <span className="text10">
                          {DataJson.text10}
                        </span>
                        <span className="text6">{DataJson.text6}</span>

                      </div>
                      <div className="Content3">
                        <div className="Content3Icon">
                          <img src={Icon1} alt="Icon1" />
                          <span className="text11">{DataJson.text11}</span>
                        </div>
                        <span className="text14">{DataJson.text14}</span>
                        <div className="textBox">
                          <span className="text12">{DataJson.text12}</span>
                          <span className="text13">{DataJson.text13}</span>
                        </div>
                        <span className="text7">{DataJson.text7}</span>
                      </div>
                      <div className="dottedHr">
                        <div className="NumberSet">
                        <p className="Number">{DataJson.number4}</p>

                          <p className="Number">{DataJson.number1}</p>
                          <p className="Number">{DataJson.number2}</p>
                          <p className="Number">{DataJson.number3}.</p>
                          <p className="dotes"></p>
                        </div>
                      </div>

                    </div>
                    <div className="CardContent"></div>
                  </div>
                  <div className="FooterMain">
                    <div className="HowItWorkFooter" dangerouslySetInnerHTML={{ __html: DataJson.footer }}></div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>)}
          {device === 0 && (
            <div className="HowItWorksMobile">
              <div className="HowItWorks1">
                <img className="HowItWorksMobileImg" src="assets/HowItWorks/Group6982.svg" />
                <div className="HowItWorks1stcontent">
                  <div className="HowItContent">Meet Ravi</div>
                  <div className="HowItSubContent">35 year old</div>
                </div>
              </div>
              <div className="HowItWorks2">
                {HowItWorksJson.map((value, indev) => (
                  <div>
                    <div className="HowItContent">{value["Content"]}</div>
                    <div className="HowItSubContent">{value["SubContent"]}</div>
                  </div>
                ))}

              </div>
              <div className="modalbutton">
                <div className="smallButtonDefault" onClick={() => CommonStore.setStoryModal(true)}>View Story</div>
              </div>
              <HowWorkModal />
            </div>
          )}
        </div>
      </div>
    </div>
  )
})

export default HowItWorks
